'use client';

import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper } from 'swiper/react';

export const BannerSlider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        '& .swiper': {
          paddingBottom: '2rem',
          '& .swiper-slide': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          '& .swiper-pagination': {
            bottom: '1rem',
          },
          '& .swiper-pagination-bullet-active': {
            backgroundColor: 'secondary.dark',
          },
        },
      }}
    >
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {children}
      </Swiper>
    </Box>
  );
};
